// Section component for getting full-bleed background color
import styled from 'styled-components'

type FullWidthSectionProps = {
  dark?: boolean
  darker?: boolean
  lightGray?: boolean
  gradient?: boolean
}

const FullWidthSection = styled.section<FullWidthSectionProps>`
  width: 100%;

  /* Dark or light options */
  background-color: ${props =>
    props.dark
      ? props.theme.colorDarkBlue
      : props.lightGray
      ? props.theme.colorVeryLightGray
      : props.darker
      ? props.theme.colorVeryDarkBlue
      : props.theme.colorWhite};

  ${props =>
    props.gradient &&
    `background-image: linear-gradient(to right, #91CBDD, #0F4D68);`}

  color: ${props =>
    // for dark background options, use white color
    // default to dark gray color
    ((props.dark || props.darker || props.gradient) &&
      props.theme.colorWhite) ||
    props.theme.colorVeryDarkBlue};
`

export default FullWidthSection
